/*
 * @Author: 317473294@qq.com
 * @Date: 2023-10-22 14:09:54
 * @LastEditTime: 2023-10-26 19:45:20
 * @LastEditors: 317473294@qq.com
 * @Description: 
 * @FilePath: /english_admin_v1.1.0/src/utils/rolemenu.js
 */
import { getRoleMenuIds } from "@/api/role.js"
//获取角色权限菜单ID
export function roleMenu(data){
    return new Promise((resolve,rejcect)=>{
        getRoleMenuIds(data).then((res) => {
          const ids = res.data.data
          resolve(ids)  
      })
      })  
}


// WEBPACK FOOTER //
// ./src/utils/rolemenu.js